export const chatMessages = (state = [[]], action) => {
  if (action.type === "LOAD_MESSAGES") {
    return [action.chatMessages, action.myMessageIds]
  }
  if (action.type === "RESET") {
    return [[]]
  }
  return state
}
